import { owcTheme } from 'core/theme/theme.config';
import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { PocComponentHeader } from 'commons/components/components-wrapper/poc-component-header.component';
import styled from 'styled-components';

export const DeviceConfigStatusTrackingHeader = styled(PocComponentHeader).attrs({
    slot: 'header',
    separator: false,
})`
    padding: 0;

    & {
        border-bottom: none;
    }
`;

export const DeviceConfigStatusTrackingContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 1.5rem;

    &.disabled owc-typography,
    &.disabled owc-input {
        color: ${owcTheme['one-color-interaction-disabled-intensity-medium']};
        pointer-events: none;
    }
`;

export const DeviceConfigStatusTrackingCardStyled = styled(PocCard)`
    width: 100%;
    max-width: 700px;
    padding: 24px;
`;
